module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AP")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "90px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "300px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Welcome_spooky#Wel"
    }
  }, [_vm._v("Welcome to Spooky Dallas!")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downtown Disturbances")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _c('td', [_vm._v("Texas School Book Depository")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _c('td', [_vm._v("Majestic Theater")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 "), _c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Souls in Old City Park")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Hotels and Cemeteries")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _c('td', [_vm._v("The Adolphus Hotel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _c('td', [_vm._v("The Stoneleigh Hotel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _c('td', [_vm._v("Hotel Lawrence")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7")]), _c('td', [_vm._v("Baccus Cemetery")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8")]), _c('td', [_vm._v("Pleasant Valley Cemetery")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9")]), _c('td', [_vm._v("Mills Cemetary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 "), _c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strange Sights at Snuffer’s")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11 "), _c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lady of White Rock Lake")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 "), _c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unexpected Experiences at Unity of Dallas")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13 "), _c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts with Good Taste")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13")]), _c('td', [_vm._v("The Dallas Arboretum and Botanical Garden")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("14")]), _c('td', [_vm._v("DeGolyer House")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("15")]), _c('td', [_vm._v("Sons of Hermann Hall")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("16")]), _c('td', [_vm._v("Sammons Center for the Arts")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spooky Suburbs")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("17")]), _c('td', [_vm._v("Red Oak")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("18")]), _c('td', [_vm._v("Waxahachie")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("19")]), _c('td', [_vm._v("Cleburne")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 "), _c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysteries in McKinney")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Ghostly_goodbye#Ghos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ghostly Goodbye")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0